import { ArrayFieldTemplateProps } from "@rjsf/utils";
import CustomArrayTemplate from "./arrays/CustomArrayTemplate";
import GalleryArrayTemplate from "./arrays/GalleryArrayTemplate";
import CategoriesArrayTemplate from "./arrays/CategoriesArrayTemplate";
import SliderArrayTemplate from "./arrays/SliderArrayTemplate";
import FeaturedProductsArrayTemplate from "./arrays/FeaturedProductsArrayTemplate";
import MarketPlaceFeaturesArrayTemplate from "./arrays/MarketPlaceFeaturesArrayTemplate";
import DocumentsArrayTemplate from "./arrays/DocumentsArrayTemplate";

function PageFormArrayTemplate(props: ArrayFieldTemplateProps) {
  let id = props.idSchema.$id;
  let type = props.uiSchema ? props.uiSchema["ui:type"] : "null";
  let className = id !== "root_sections" ? "cms-section" : "";

  if (type === "gallery" || type === "gallery_with_main") {
    return GalleryArrayTemplate(props, className, id);
  } else if (type === "market_place_features") {
    return MarketPlaceFeaturesArrayTemplate(props, className, id);
  } else if (type === "categories" || type === "sidebar_categories") {
    return CategoriesArrayTemplate(props, className, id);
  } else if (type === "featured_products") {
    return FeaturedProductsArrayTemplate(props, className, id);
  } else if (type === "slider") {
    return SliderArrayTemplate(props, className, id);
  } else if (type === "documents") {
    return DocumentsArrayTemplate(props, className, id);
  } else {
    return CustomArrayTemplate(props, className, id);
  }
}

export default PageFormArrayTemplate;
